import React from 'react'
import PropTypes from 'prop-types'
import Navbar from 'containers/Navbar'
import { Notifications } from 'modules/notification'

export const CoreLayout = ({ children, classes }) => (
  <div className={classes.root}>
    <Navbar />
    <main className={classes.content}>{children}</main>
    <Notifications />
  </div>
)

CoreLayout.propTypes = {
  classes: PropTypes.object.isRequired, // from enhancer (withStyles)
  children: PropTypes.element.isRequired,
}

export default CoreLayout
